module.exports = __webpack_public_path__ + "img/hr-tree-06-h-trunk.37220efc.png";